module.exports = __webpack_public_path__ + "static/media/21.9d03a7ec.jpg";